<template>
    <v-dialog v-model="dialogModel" max-width="800">
        <v-card light style="opacity: 0.95;">
            <v-alert type="info" dense class="body-2 mb-0">Component translations</v-alert>
            <v-card-text>

                <v-text-field v-model="passwordFieldLabelModel"
                              persistent-hint
                              hint="Password field label"
                ></v-text-field>

                <v-text-field v-model="passwordConfirmationFieldLabelModel"
                              persistent-hint
                              hint="Password confirmation field label"
                ></v-text-field>

                <v-text-field v-model="passwordSecurityIndicatorLabelModel"
                              persistent-hint
                              hint="Password security indicator label"
                ></v-text-field>

                <v-text-field v-model="passwordValidationRequiredModel"
                              persistent-hint
                              hint="Password not entered validation error"
                ></v-text-field>

                <v-text-field v-model="passwordValidationComplexityModel"
                              persistent-hint
                              hint="Password complexity validation error"
                ></v-text-field>

                <v-text-field v-model="passwordValidationMismatchModel"
                              persistent-hint
                              hint="Passwords do not match validation error"
                ></v-text-field>

            </v-card-text>
        </v-card>
    </v-dialog>

</template>

<script>

    export default {

        props: {
            value: {
                required: true,
                type: Boolean,
            },
            subPanelTranslations: {
                required: true,
                type: Object,
            }
        },

        computed: {
            dialogModel: {
                get() {
                    return this.value;
                },
                set(value) {
                    this.$emit('input', value);
                }
            },

            passwordFieldLabelModel: {
                get() {
                    return this.subPanelTranslations.survey_password_field_label;
                },
                set(value) {
                    this.$emit('change', {survey_password_field_label: value});
                }
            },

            passwordConfirmationFieldLabelModel: {
                get() {
                    return this.subPanelTranslations.survey_password_confirmation_field_label;
                },
                set(value) {
                    this.$emit('change', {survey_password_confirmation_field_label: value});
                }
            },

            passwordSecurityIndicatorLabelModel: {
                get() {
                    return this.subPanelTranslations.survey_password_security_indicator_label;
                },
                set(value) {
                    this.$emit('change', {survey_password_security_indicator_label: value});
                }
            },

            passwordValidationMismatchModel: {
                get() {
                    return this.subPanelTranslations.survey_password_validation_mismatch;
                },
                set(value) {
                    this.$emit('change', {survey_password_validation_mismatch: value});
                }
            },

            passwordValidationComplexityModel: {
                get() {
                    return this.subPanelTranslations.survey_password_validation_complexity;
                },
                set(value) {
                    this.$emit('change', {survey_password_validation_complexity: value});
                }
            },

            passwordValidationRequiredModel: {
                get() {
                    return this.subPanelTranslations.survey_password_validation_required;
                },
                set(value) {
                    this.$emit('change', {survey_password_validation_required: value});
                }
            },
        }
    }
</script>
